import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAlloysPartnersShopifyFetchMarketsResult = objectOf({
  markets: arrayOf(
    objectOf({
      id: string,
      name: string,
      handle: string,
      catalog_id: string,
      countries: arrayOf(
        objectOf({
          code: string,
          name: string,
        })
      ),
      default_locale: maybe(string, true),
    })
  ),
});
